import styled from 'styled-components';

import { StyledClickableContainer as DefaultStyledClickableContainer } from './external-incentive-card.styled.default';

export * from './external-incentive-card.styled.default';

export const StyledClickableContainer = styled(DefaultStyledClickableContainer)`
  padding: 0.75rem;
`;
